import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/6066366666674f258b0d910435433b76.jpg"
            alt="Semeiks Law Office"
            className="absolute inset-0 w-full h-full object-cover object-top animate-slow-zoom"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
          <div className="mb-8 inline-block bg-[#D8DADD] backdrop-blur-sm px-6 py-4 rounded-2xl shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/17bd7862-e3c7-44a7-b153-3cd04a9dd63a.png"
              alt="Semeiks Law"
              className="h-48 w-auto mx-auto"
            />
          </div>
          <h1 className="sr-only">Semeiks Law</h1>
          <p className="text-2xl md:text-3xl text-white/95 mb-12 font-light tracking-wide">
            Clear legal guidance for individuals and businesses
          </p>
          <Link 
            to="/contact"
            className="inline-block bg-[#1A2332] text-white px-12 py-4 rounded-lg text-base font-medium hover:bg-[#2C3540] transition-colors duration-300 whitespace-nowrap"
          >
            Schedule a Consultation
          </Link>
        </div>
      </section>

      {/* Services Overview Grid */}
      <section className="py-32 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Service Card 1 */}
            <div className="bg-[#F8F9FA] rounded-2xl p-10 hover:bg-[#F0F1F3] hover:shadow-lg transition-all duration-300">
              <div className="w-8 h-8 flex items-center justify-center mb-6">
                <i className="ri-file-text-line text-3xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Contract Review &amp; Drafting
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                Clear, enforceable contracts that protect your interests and prevent future disputes.
              </p>
              <Link to="/services" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Learn more →
              </Link>
            </div>

            {/* Service Card 2 */}
            <div className="bg-[#F8F9FA] rounded-2xl p-10 hover:bg-[#F0F1F3] hover:shadow-lg transition-all duration-300">
              <div className="w-8 h-8 flex items-center justify-center mb-6">
                <i className="ri-building-line text-3xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Business Formation
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                Set up your business structure correctly from the start, with proper legal foundations.
              </p>
              <Link to="/services" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Learn more →
              </Link>
            </div>

            {/* Service Card 3 */}
            <div className="bg-[#F8F9FA] rounded-2xl p-10 hover:bg-[#F0F1F3] hover:shadow-lg transition-all duration-300">
              <div className="w-8 h-8 flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Asset Protection
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                Smart strategies to safeguard your assets and minimize legal risks in your business.
              </p>
              <Link to="/services" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Learn more →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Approach Statement Section */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-16 items-center">
            <div className="md:col-span-4">
              <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
                Our Approach
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] leading-tight">
                Legal guidance that makes sense
              </h2>
            </div>
            <div className="md:col-span-8">
              <p className="text-lg text-[#374151] mb-6 leading-relaxed">
                We believe legal help should be straightforward. No confusing jargon, no unnecessary complexity, and no inflated bills for simple work. Our job is to give you clear advice, strong documents, and practical solutions that actually work in the real world.
              </p>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                Whether you're starting a business, reviewing a contract, or protecting your assets, we focus on what matters: helping you understand your options and making sure you're legally protected.
              </p>
              <Link 
                to="/about"
                className="inline-block border-2 border-[#1A2332] text-[#1A2332] px-8 py-3 rounded-lg font-medium hover:bg-[#1A2332] hover:text-white transition-all duration-300 whitespace-nowrap"
              >
                See how we work
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Help Section */}
      <section className="py-32 px-6 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
              Who we help
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A2332] mb-6">
              Legal support tailored to your situation
            </h2>
            <p className="text-lg text-[#6B7280] max-w-2xl mx-auto">
              We work with individuals and businesses at every stage, providing practical legal guidance that fits your specific needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Small Business Owners */}
            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4704B]/10 rounded-xl mb-6">
                <i className="ri-store-2-line text-2xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Small Business Owners
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                Running a small business means wearing many hats. We help you handle the legal side so you can focus on what you do best — serving your customers and growing your business.
              </p>
              <div className="border-t border-[#E5E7EB] pt-6">
                <p className="text-sm font-semibold text-[#1A2332] mb-3">Common services:</p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Contract Review</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Vendor Agreements</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Employment Contracts</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Business Counsel</span>
                </div>
              </div>
            </div>

            {/* Entrepreneurs */}
            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4704B]/10 rounded-xl mb-6">
                <i className="ri-rocket-line text-2xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Entrepreneurs
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                Starting something new is exciting, but getting the legal foundation right from day one saves headaches later. We help you launch with confidence and proper protection.
              </p>
              <div className="border-t border-[#E5E7EB] pt-6">
                <p className="text-sm font-semibold text-[#1A2332] mb-3">Common services:</p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Business Formation</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Operating Agreements</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Partnership Agreements</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">NDAs</span>
                </div>
              </div>
            </div>

            {/* Property Owners */}
            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4704B]/10 rounded-xl mb-6">
                <i className="ri-home-4-line text-2xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Property Owners
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                Whether you own rental properties, commercial real estate, or are buying and selling, having proper legal documentation protects your investment and minimizes risk.
              </p>
              <div className="border-t border-[#E5E7EB] pt-6">
                <p className="text-sm font-semibold text-[#1A2332] mb-3">Common services:</p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Lease Agreements</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Purchase Contracts</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Asset Protection</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Entity Structuring</span>
                </div>
              </div>
            </div>

            {/* Growing Companies */}
            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4704B]/10 rounded-xl mb-6">
                <i className="ri-line-chart-line text-2xl text-[#C4704B]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                Growing Companies
              </h3>
              <p className="text-base text-[#6B7280] mb-6 leading-relaxed">
                As your business scales, legal needs become more complex. We provide ongoing counsel to help you navigate growth challenges, manage risk, and seize opportunities.
              </p>
              <div className="border-t border-[#E5E7EB] pt-6">
                <p className="text-sm font-semibold text-[#1A2332] mb-3">Common services:</p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Commercial Agreements</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Compliance</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">HR Legal Support</span>
                  <span className="text-sm bg-[#F8F9FA] text-[#374151] px-3 py-1.5 rounded-full">Strategic Planning</span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-16">
            <Link 
              to="/services"
              className="inline-block border-2 border-[#1A2332] text-[#1A2332] px-8 py-3 rounded-lg font-medium hover:bg-[#1A2332] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View all services
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
